import React, { useState, useEffect } from 'react'
import moment from 'moment'

import {
    to12Hr
} from '../../helpers/moment'

import { config } from '../../config/index'
import UploadFile from '../../components/Input/UploadFile'
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import PageShell from "../../components/UI/PageShell";
const { API_URL } = config

const UploadProof = ({ match: { params: { schedule_id } } }) => {
    const token = localStorage.getItem('token')
    const user  = JSON.parse(localStorage.getItem('user'))

    const [schedule, setSchedule] = useState(null)
    const [shift, setShift]       = useState(null)
    const [status, setStatus]     = useState(null)

    const fetchSchedule = async () => {
        let url = `${API_URL}/schedule/${schedule_id}`

        try {
            let response = await fetch(url, {
                mode: "cors",
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization: token,
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json charset=utf-8"
                }
            })

            let data = await response.json()

            if (response.ok) {
                setSchedule(data.data)
            } else {
                ToastUtil.error(response.message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchStatus = async () => {
        let url = `${API_URL}/schedule/${schedule_id}/associate/${user.id}`

        try {
            let response = await fetch(url, {
                method: 'GET',
                withCredentials: true,
                mode: 'cors',
                headers: {
                    "Authorization": token,
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json; charset=utf-8",
                }
            })

            let responseData = await response.json()

            if (response.ok) {
                setStatus({...responseData.data.statusObj, reason: responseData.data.reason})
            } else {
                ToastUtil.error(responseData.message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchSchedule()
        fetchStatus()
    }, [schedule_id])
    
    return (
        <PageShell title="Upload proof" eyebrow="Attendance documentation" description="Provide the required document for this scheduled shift." backTo="/time-clock">
            {
                (schedule && status) && (
                    <div className="portal-form-card">
                        <div className="portal-form-section-title">
                          <h2>Documentation required</h2>
                          <p>Please review the shift details before uploading your file.</p>
                        </div>
                        <div className="portal-notice portal-notice--warning">
                            You are required to upload a Proof of Documentation for <strong>{status.reason}</strong> on <strong>{moment(schedule.date, 'YYYY-MM-DD').format('ddd, DD MMMM YYYY')}, {schedule.shift.name} ({to12Hr(schedule.shift.start_time)} - {to12Hr(schedule.shift.end_time)})</strong>.
                            <br/>
                            <br/>
                            Failure to do so, it will considered as missed shift and you will be marked as absent.
                        </div>
                        <div className="border-top mt-3 pt-3"><UploadFile url={`${API_URL}/associate/shift/${schedule_id}/document/upload`} /></div>
                    </div>
                )
                
            }
        </PageShell>
    )
}

export default UploadProof
